import { ReactNode } from "react";

import { Box } from "@/components/layout/flexbox";
import { SUBTEXT_COLOR } from "@/css/constants";

interface SubtitleProps {
  children: ReactNode;
}

export function Subtitle({ children }: SubtitleProps) {
  return (
    <Box fontSize={16} color={SUBTEXT_COLOR}>
      {children}
    </Box>
  );
}
